export const enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export type SortOrderType = SortOrder.Asc | SortOrder.Desc;
